import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  candidateSelectedPool: null as number | null, // Add candidateSelectedPool to the state
  candidateSelectedIds: [] as number[],
  selectedCandidates: [] as any[],
  reduxShortlistedCandidates: [] as any[],
  selectedScreeningCadidateName: null as string | null,
  candidateSelectedScreeningRecord: {},
};

// Redux Toolkit slice
const candidateScreeningSlice = createSlice({
  name: "candidateScreening",
  initialState,
  reducers: {
    setcandidateSelectedPool: (state, action: PayloadAction<number | null>) => {  // New action to set candidateSelectedPool
      state.candidateSelectedPool = action.payload;
    },
    setcandidateSelectedScreeningRecord: (state, action: PayloadAction<any>) => {
      state.candidateSelectedScreeningRecord = action.payload;
    },
    setCandidateSelectedIds: (state, action: PayloadAction<number[]>) => {  // Updated to accept an array of numbers
      state.candidateSelectedIds = action.payload;
    },
    setSelectedCandidates: (state, action: PayloadAction<any[]>) => {  // Updated to accept an array of selected candidates
      state.selectedCandidates = action.payload;
    },
    setSelectedScreeningCadidateName: (state, action: PayloadAction<string | null>) => {  // Updated to accept an array of selected candidates
      state.selectedScreeningCadidateName = action.payload;
    },
    setReduxShortlistedCandidates: (state, action: PayloadAction<any[]>) => {  // Updated to accept an array of selected candidates
      console.log("=======action.payload", action.payload);
      state.reduxShortlistedCandidates = action.payload;
    },
  },
});

// Export the actions
export const { setcandidateSelectedPool, setcandidateSelectedScreeningRecord, setSelectedScreeningCadidateName, setCandidateSelectedIds, setSelectedCandidates, setReduxShortlistedCandidates } = candidateScreeningSlice.actions;

// Export the reducer
export default candidateScreeningSlice.reducer;
